/**
 * Created by gavin on 19/1/11.
 */
import axios from "../../utils/axios";

// 关于我们
export function aboutUs(query) {
    return axios({
        url: "/aboutUs/getInfo",
        method: "get",
        params: query
    });
}

// 用户协议
export function userAgreement(query) {
    return axios({
        url: "/treaty/getInfo",
        method: "get",
        params: query
    });
}
// 帮助详情
export function help(query) {
    return axios({
        url: "/help/getInfo",
        method: "get",
        params: query
    });
}
// 公司介绍
export function introduct(query) {
    return axios({
        url: "/introduce/getInfo",
        method: "get",
        params: query
    });
}

// 修改 关于我们
export function editaboutUs(data) {
    return axios({
        url: "/aboutUs/update",
        method: "post",
        data: data
    });
}

// 修改 公司介绍
export function editintroduce(data) {
    return axios({
        url: "/introduce/update",
        method: "post",
        data: data
    });
}
// 获取  如何查找序列号
export function getSri(data) {
    return axios({
        url: "/help/update4",
        method: "post",
        data: data
    });
}
// 修改  如何查找序列号
export function editSri(data) {
    return axios({
        url: "/help/update4",
        method: "post",
        data: data
    });
}
// 修改  用户协议
export function edittreaty(data) {
    return axios({
        url: "/treaty/update",
        method: "post",
        data: data
    });
}
// 修改  帮助详情
export function editHelp(data) {
    return axios({
        url: "/help/update",
        method: "post",
        data: data
    });
}
